'use client'
import { useEffect, useRef } from 'react'

interface Props {
  user: string
  domain: string
  className?: string
  style?: React.CSSProperties
}

/**
 * Renders a mailto link that is assembled client-side so the address
 * never appears in the static HTML served to scrapers.
 */
export default function MailLink({ user, domain, className, style }: Props) {
  const ref = useRef<HTMLAnchorElement>(null)
  useEffect(() => {
    const email = `${user}@${domain}`
    if (ref.current) {
      ref.current.href = `mailto:${email}`
      ref.current.textContent = email
    }
  }, [user, domain])
  return <a ref={ref} className={className} style={style} />
}
